import { render, staticRenderFns } from "./UserBookList.vue?vue&type=template&id=225be814&"
import script from "./UserBookList.vue?vue&type=script&lang=js&"
export * from "./UserBookList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports